// My Account tab (cross-backend → admin-corev2): password change, letterhead
// signed-url upload. Same method surface as admin-ui's accountSetting.js so the
// ported component reads identically; only the transport (adminRequest/s3Put) differs.
import { adminRequest, s3Put } from './client.js';

const api = {
	// PUT /user/:userId — password (and other user) update.
	update: (userId, params) => adminRequest('PUT', `/user/${userId}`, params),

	// GET /org/:orgId/files/signedurl/:type/:extension
	getSignedUrl: (orgId, file, type) => {
		const fileToUpload = file[0];
		const parts = fileToUpload.name.split('.');
		const extension = parts[parts.length - 1];
		return adminRequest('GET', `/org/${orgId}/files/signedurl/${type}/${extension}`);
	},

	// Cross-origin PUT to S3 (no admin/routing headers — see client.s3Put).
	uploadFileToSignedURL: (uploadUrl, file) => s3Put(uploadUrl, file[0]),

	// POST /org/:orgId/files/upload-document-logo/document-logo
	uploadDocumentLogo: (orgId, body) =>
		adminRequest('POST', `/org/${orgId}/files/upload-document-logo/document-logo`, body),
};

export default api;
